import { minWidth } from '../Drawer.styled';

export function getDrawerSize(changeStudents, changeActivities) {
  let drawerSize = minWidth;

  switch (true) {
    case changeStudents && changeActivities:
      drawerSize = '99%';
      break;
    case changeStudents:
      drawerSize = '66%';
      break;
    case changeActivities:
      drawerSize = '75%';
      break;
    default:
      drawerSize = 550;
  }
  return drawerSize;
}
